import { CommonModule, formatDate } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, EventEmitter, Output, NgModule, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NativeDateAdapter, DateAdapter } from '@angular/material/core';
import merge from 'deepmerge';

class XpoDynamicMenuBlockDirective {
}
XpoDynamicMenuBlockDirective.ɵfac = function XpoDynamicMenuBlockDirective_Factory(t) { return new (t || XpoDynamicMenuBlockDirective)(); };
XpoDynamicMenuBlockDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDynamicMenuBlockDirective, selectors: [["", "xpo-dynamic-menu-block", ""], ["", "xpoDynamicMenuBlock", ""]], hostAttrs: [1, "xpo-DynamicMenu--block"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDynamicMenuBlockDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-dynamic-menu-block], [xpoDynamicMenuBlock]',
                host: {
                    class: 'xpo-DynamicMenu--block',
                },
            }]
    }], null, null); })();

class XpoDynamicMenuDirective {
    constructor(hostElement, renderer) {
        this.hostElement = hostElement;
        this.renderer = renderer;
        this.MORE_BUTTON_CLASS = 'xpo-DynamicMenu--block';
        this.STYLE_DISPLAY = 'display';
        this.STYLE_NONE = 'none';
        this.DEBOUNCE_TIME = 500;
        this.resize$ = new Subject();
        this.firstLoad = true;
        this.hiddenElements = [];
        this.hiddenButtonsWidth = [];
        this.hiddenBtnEvent = new EventEmitter();
    }
    ngOnInit() {
        /**
         * Create a resize observer over this whole component and dispatching evalButtonsDisplay
         * when width or height changes
         */
        this.observer = new ResizeObserver(() => this.resize$.next());
        this.observer.observe(this.hostElement.nativeElement);
        this.resize$.pipe(debounceTime(this.DEBOUNCE_TIME)).subscribe(() => this.evalButtonsDisplay());
    }
    evalButtonsDisplay() {
        this.hiddenElements = this.executeMeasurement();
        if (this.hiddenElements) {
            this.hiddenBtnEvent.emit(this.hiddenElements);
        }
        this.firstLoad = false;
    }
    executeMeasurement() {
        // Get group of hidden and showed buttons
        const btnGroups = {
            visibleButtons: this.getVisibleButtons(),
            nonVisibleButtons: this.getNonVisibleButtons(),
        };
        // Get the navbar extra space after buttons
        this.extraSpace = this.getExtraSpace(btnGroups.visibleButtons);
        // If remaining space is less than the 0 we have to hide some buttons
        const haveToHideCondition = btnGroups.visibleButtons.length && this.extraSpace < 0;
        // If remaining space is more than the btnAverageWidth we can possible show hidden button
        const haveToShowCondition = btnGroups.nonVisibleButtons.length && this.extraSpace > this.hiddenButtonsWidth[this.hiddenButtonsWidth.length - 1];
        if (haveToHideCondition || haveToShowCondition) {
            this.executeHideAndShow(btnGroups, haveToHideCondition);
        }
        return this.getNonVisibleButtons();
    }
    executeHideAndShow(btnGroups, haveToHideCondition) {
        if (haveToHideCondition) {
            this.hideButtons(btnGroups.visibleButtons);
        }
        else {
            this.showButtons(btnGroups.nonVisibleButtons);
        }
    }
    hideButtons(visibleButtons) {
        let currentExtraSpace = this.extraSpace;
        visibleButtons.reverse().some((nextVisibleButton) => {
            if (currentExtraSpace < 0) {
                currentExtraSpace += this.getElementWidth(nextVisibleButton);
                this.hiddenButtonsWidth.push(this.getElementWidth(nextVisibleButton));
                this.renderer.setStyle(nextVisibleButton, this.STYLE_DISPLAY, this.STYLE_NONE);
            }
            else {
                // Returning true breaks the iteration
                return true;
            }
        });
    }
    showButtons(nonVisibleButtons) {
        let currentExtraSpace = this.extraSpace;
        nonVisibleButtons.some((nextNonVisibleButton) => {
            if (this.hiddenButtonsWidth && currentExtraSpace > this.hiddenButtonsWidth[this.hiddenButtonsWidth.length - 1]) {
                currentExtraSpace -= this.hiddenButtonsWidth[this.hiddenButtonsWidth.length - 1];
                this.renderer.removeStyle(nextNonVisibleButton, this.STYLE_DISPLAY);
                this.hiddenButtonsWidth.pop();
            }
            else {
                // Returning true breaks the iteration
                return true;
            }
        });
    }
    getExtraSpace(visibleButtons) {
        const containerWidth = this.getElementWidth(this.hostElement.nativeElement);
        const visibleBtnWidth = this.getVisibleBtnWidth(visibleButtons);
        const moreBtnWidth = this.getMoreBtnWidth();
        return containerWidth - (visibleBtnWidth + moreBtnWidth);
    }
    getNonVisibleButtons() {
        // Get elements from host that aren't block and are hide (width === 0)
        return Array.from(this.hostElement.nativeElement.children)
            .filter((child) => !child.classList.contains(this.MORE_BUTTON_CLASS) && child.offsetWidth === 0);
    }
    getVisibleButtons() {
        // Get elements from host that aren't block and aren't hide (has width)
        return Array.from(this.hostElement.nativeElement.children)
            .filter((child) => !child.classList.contains(this.MORE_BUTTON_CLASS) && child.offsetWidth);
    }
    getVisibleBtnWidth(visibleButtons) {
        // Iterate every button to calculate the complete width occupied for them
        let visibleBtnWidth = 0;
        visibleButtons.forEach((btn) => {
            visibleBtnWidth += this.getElementWidth(btn);
        });
        return visibleBtnWidth;
    }
    getMoreBtnWidth() {
        if (this.firstLoad) {
            this.blockedButton = this.getMoreBtn();
        }
        return this.blockedButton ? this.getElementWidth(this.blockedButton) : 0;
    }
    getMoreBtn() {
        // Get the width of the block element using his special class
        return Array.from(this.hostElement.nativeElement.children)
            .filter((child) => child.classList.contains(this.MORE_BUTTON_CLASS))[0];
    }
    getElementWidth(element) {
        const style = window.getComputedStyle(element);
        // width + margin of each element
        return element.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    }
    ngOnDestroy() {
        var _a;
        (_a = this.observer) === null || _a === void 0 ? void 0 : _a.unobserve(this.hostElement.nativeElement);
        this.resize$.complete();
    }
}
XpoDynamicMenuDirective.ɵfac = function XpoDynamicMenuDirective_Factory(t) { return new (t || XpoDynamicMenuDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
XpoDynamicMenuDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDynamicMenuDirective, selectors: [["", "xpo-dynamic-menu", ""], ["", "xpoDynamicMenu", ""]], outputs: { hiddenBtnEvent: "hiddenBtnEvent" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDynamicMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[xpo-dynamic-menu], [xpoDynamicMenu]',
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { hiddenBtnEvent: [{
            type: Output
        }] }); })();

class XpoUtilsModule {
}
XpoUtilsModule.ɵfac = function XpoUtilsModule_Factory(t) { return new (t || XpoUtilsModule)(); };
XpoUtilsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoUtilsModule });
XpoUtilsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoUtilsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [XpoDynamicMenuDirective, XpoDynamicMenuBlockDirective],
                exports: [XpoDynamicMenuDirective, XpoDynamicMenuBlockDirective],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoUtilsModule, { declarations: [XpoDynamicMenuDirective, XpoDynamicMenuBlockDirective], imports: [CommonModule], exports: [XpoDynamicMenuDirective, XpoDynamicMenuBlockDirective] }); })();

function hexToRGBA(hex, opacity = 1) {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        // eslint-disable-next-line no-bitwise
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
    }
    throw new Error('Bad Hex');
}

class DateUtils {
    constructor() { }
    static formatTimeString(time) {
        return time ? time.replace('/^[0]+/g', '') : '';
    }
    static formatDate(date) {
        return date ? date.toLocaleDateString('en-US') : '';
    }
    static formatDateTime(date, dateTimeFormatOptions) {
        const defaultDateTimeFormatOptions = {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        };
        if (dateTimeFormatOptions) {
            dateTimeFormatOptions = Object.assign(Object.assign({}, defaultDateTimeFormatOptions), dateTimeFormatOptions);
            return date ? date.toLocaleString('en-US', dateTimeFormatOptions) : '';
        }
        else {
            return date ? date.toLocaleString('en-US', defaultDateTimeFormatOptions).replace(',', '') : '';
        }
    }
    static firstDayOfWeek(offset = 0) {
        const dayOfWeek = DateUtils.today().getDay();
        return DateUtils.fromToday(-1 * dayOfWeek + offset * 7);
    }
    static fromNow(offset) {
        const date = DateUtils.today();
        date.setHours(date.getHours() + offset);
        return date;
    }
    static fromToday(offset, interval = 'day') {
        switch (interval) {
            case 'day': {
                return new Date(DateUtils.today().getTime() + this.millisecondsPerDay * offset);
            }
            case 'week': {
                return new Date(DateUtils.today().getTime() + this.millisecondsPerWeek * offset);
            }
            // case 'month': {
            //   let endDate = DateUtils.today().
            // }
            default: {
                return new Date(DateUtils.today().getTime() + this.millisecondsPerDay * offset);
            }
        }
    }
    static lastDayOfWeek(offset = 0) {
        const dayOfWeek = DateUtils.today().getDay();
        return DateUtils.fromToday(6 - dayOfWeek + offset * 7);
    }
    static today() {
        return new Date();
    }
    static tomorrow() {
        return DateUtils.fromToday(1);
    }
    static yesterday() {
        return DateUtils.fromToday(-1);
    }
    static firstDayOfMonth(offset = 0) {
        const date = DateUtils.today();
        date.setMonth(date.getMonth() + offset);
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }
    static lastDayOfMonth(offset = 0) {
        const date = DateUtils.today();
        date.setMonth(date.getMonth() + offset);
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }
    static firstDayOfQuarter(offset = 0) {
        const quarter = Math.floor(DateUtils.today().getMonth() / 3) + 1;
        return new Date(DateUtils.today().getFullYear(), quarter * 3 - 3 + 3 * offset, 1);
    }
    static lastDayOfQuarter(offset = 0) {
        const date = DateUtils.firstDayOfQuarter(offset);
        return new Date(date.getFullYear(), date.getMonth() + 3, 0);
    }
    static getQuarter(date) {
        date = date || new Date(); // If no date supplied, use today
        const q = [1, 2, 3, 4];
        return q[Math.floor(date.getMonth() / 3)];
    }
    static firstDayOfYear(offset = 0) {
        return new Date(new Date().getFullYear() + offset, 0, 1);
    }
    static lastDayOfYear(offset = 0) {
        return new Date(new Date().getFullYear() + offset, 11, 31);
    }
    static getTimeString(date) {
        return formatDate(date, 'HH:mm:ss', 'en-US');
    }
    static getDateFromOffset(offsetInSeconds) {
        const date = new Date();
        const utc = date.getTime() + date.getTimezoneOffset() * 60000;
        return new Date(utc + offsetInSeconds * 1000);
    }
    /**
     * Returns new date with the time set to the entered time value
     *
     */
    static combineDateAndTime(date, time) {
        if (!date || !time) {
            return;
        }
        const [hours, min, sec] = time.split(':').map((v) => Number.parseInt(v, 10));
        return new Date(new Date(date).setHours(hours, min, sec || 0));
    }
    static crossBrowserToLocaleString(date) {
        return date ? formatDate(date, 'yyyy-MM-ddTHH:mm:ss', 'en-US') : '';
    }
}
DateUtils.millisecondsPerDay = 24 * 60 * 60 * 1000;
DateUtils.millisecondsPerWeek = 7 * DateUtils.millisecondsPerDay;

class XpoNativeDateAdapter extends NativeDateAdapter {
    parse(value, parseFormat) {
        // if the value is a timestamp
        if (typeof value == 'number') {
            return new Date(value);
        }
        let date;
        // if a format object is provided
        if (parseFormat) {
            date = this.createDateWithParseFormat(value);
        }
        else {
            date = value ? new Date(Date.parse(value)) : null;
        }
        return date;
    }
    getDayOfWeekNames() {
        return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    }
    createDateWithParseFormat(value) {
        // TODO: we need to work with this to evaluate more scenarios. This is too simple and basic :(
        // just evaluate basic format separators, they should come inside the format object
        const dateParts = value ? value.split('-').join('/').split('/') : [];
        let date;
        // try create date according to format
        // TODO: we need to evaluate here date format object
        try {
            if (dateParts.length === 3 && this.isValidMonth(+dateParts[0] - 1) && this.isValidDay(+dateParts[1])) {
                date = this.createDate(+dateParts[2], +dateParts[0] - 1, +dateParts[1]);
            }
            else if (dateParts.length === 2 && this.isValidMonth(+dateParts[0] - 1)) {
                date = this.createDate(+dateParts[1], +dateParts[0] - 1, 1);
            }
            else if (dateParts.length === 1) {
                date = this.createDate(+dateParts[0], 0, 1);
            }
            else {
                // keep as is in parent class, to let do validations when user types something other than a formatted date
                date = value ? new Date(Date.parse(value)) : null;
            }
        }
        catch (_a) {
            // silence catch just only to avoid console error when `createDate` makes validations
        }
        return date;
    }
    isValidMonth(month) {
        return month >= 0 && month <= 11;
    }
    isValidDay(day) {
        return day >= 1 && day <= 31;
    }
}
XpoNativeDateAdapter.ɵfac = /*@__PURE__*/ function () { let ɵXpoNativeDateAdapter_BaseFactory; return function XpoNativeDateAdapter_Factory(t) { return (ɵXpoNativeDateAdapter_BaseFactory || (ɵXpoNativeDateAdapter_BaseFactory = i0.ɵɵgetInheritedFactory(XpoNativeDateAdapter)))(t || XpoNativeDateAdapter); }; }();
XpoNativeDateAdapter.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoNativeDateAdapter, factory: XpoNativeDateAdapter.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNativeDateAdapter, [{
        type: Injectable
    }], null, null); })();

/**
 * Moment date formats object for DATE
 */
const XPO_DATE_PICKER_MOMENT_DATE_FORMATS = {
    parse: {
        dateInput: 'MM/DD/YYYY',
    },
    display: {
        dateInput: 'MM/DD/YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
/**
 * Moment date formats object for MONTH
 */
const XPO_DATE_PICKER_MOMENT_MONTH_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
/**
 * Moment date formats object for YEAR
 */
const XPO_DATE_PICKER_MOMENT_YEAR_FORMATS = {
    parse: {
        dateInput: 'YYYY',
    },
    display: {
        dateInput: 'YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

/**
 * Native date formats object for DATE
 */
const XPO_DATE_PICKER_NATIVE_DATE_FORMATS = {
    parse: {
        dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    },
    display: {
        dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
        monthYearLabel: { year: 'numeric', month: 'long' },
        dateA11yLabel: { month: 'long', day: 'numeric', year: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
};
/**
 * Native date formats object for MONTH
 */
const XPO_DATE_PICKER_NATIVE_MONTH_FORMATS = {
    parse: {
        dateInput: { month: '2-digit', year: 'numeric' },
    },
    display: {
        dateInput: { month: '2-digit', year: 'numeric' },
        monthYearLabel: { year: 'numeric', month: 'long' },
        dateA11yLabel: { month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
};
/**
 * Native date formats object for YEAR
 */
const XPO_DATE_PICKER_NATIVE_YEAR_FORMATS = {
    parse: {
        dateInput: { year: 'numeric' },
    },
    display: {
        dateInput: { year: 'numeric' },
        monthYearLabel: { year: 'numeric' },
        dateA11yLabel: { year: 'numeric' },
        monthYearA11yLabel: { year: 'numeric' },
    }
};

/**
 * Factory provider for DATE date formats object
 */
function XPO_DATE_ADAPTER_DATE_FORMATS_PROVIDER_FACTORY(dateAdapter) {
    // TODO: this is a hack to know if project wants to use moment instead of native adapter
    // we need to review options for custom adapters
    return (dateAdapter instanceof NativeDateAdapter || dateAdapter instanceof XpoNativeDateAdapter) ?
        XPO_DATE_PICKER_NATIVE_DATE_FORMATS :
        XPO_DATE_PICKER_MOMENT_DATE_FORMATS;
}
/**
 * Factory provider for MONTH date formats object
 */
function XPO_DATE_ADAPTER_MONTH_FORMATS_PROVIDER_FACTORY(dateAdapter) {
    // TODO: this is a hack to know if project wants to use moment instead of native adapter
    // we need to review options for custom adapters
    return (dateAdapter instanceof NativeDateAdapter || dateAdapter instanceof XpoNativeDateAdapter) ?
        XPO_DATE_PICKER_NATIVE_MONTH_FORMATS :
        XPO_DATE_PICKER_MOMENT_MONTH_FORMATS;
}
/**
 * Factory provider for YEAR date formats object
 */
function XPO_DATE_ADAPTER_YEAR_FORMATS_PROVIDER_FACTORY(dateAdapter) {
    // TODO: this is a hack to know if project wants to use moment instead of native adapter
    // we need to review options for custom adapters
    return (dateAdapter instanceof NativeDateAdapter || dateAdapter instanceof XpoNativeDateAdapter) ?
        XPO_DATE_PICKER_NATIVE_YEAR_FORMATS :
        XPO_DATE_PICKER_MOMENT_YEAR_FORMATS;
}

class XpoNativeDateModule {
}
XpoNativeDateModule.ɵfac = function XpoNativeDateModule_Factory(t) { return new (t || XpoNativeDateModule)(); };
XpoNativeDateModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoNativeDateModule });
XpoNativeDateModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        {
            provide: DateAdapter,
            useClass: XpoNativeDateAdapter
        }
    ], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNativeDateModule, [{
        type: NgModule,
        args: [{
                imports: [],
                providers: [
                    {
                        provide: DateAdapter,
                        useClass: XpoNativeDateAdapter
                    }
                ],
            }]
    }], null, null); })();

/**
 * (Nahuel Fava):
 *
 * Created this keyCode file based on Angular Material's CDK
 * https://github.com/angular/material2/blob/master/src/cdk/keycodes/keycodes.ts
 *
 */
const ESCAPE = 'Escape';
const LEFT_ARROW = 'ArrowLeft';
const RIGHT_ARROW = 'ArrowRight';

function cloneShallow(source) {
    return Array.isArray(source) ? [...source] : Object.assign({}, source);
}
function cloneDeep(source) {
    return Array.isArray(source) ? merge([], source) : merge({}, source);
}

/**
 * Generated bundle index. Do not edit.
 */

export { DateUtils, ESCAPE, LEFT_ARROW, RIGHT_ARROW, XPO_DATE_ADAPTER_DATE_FORMATS_PROVIDER_FACTORY, XPO_DATE_ADAPTER_MONTH_FORMATS_PROVIDER_FACTORY, XPO_DATE_ADAPTER_YEAR_FORMATS_PROVIDER_FACTORY, XpoDynamicMenuBlockDirective, XpoDynamicMenuDirective, XpoNativeDateAdapter, XpoNativeDateModule, XpoUtilsModule, cloneDeep, cloneShallow, hexToRGBA };
